import React from 'react';
import styled from 'styled-components';
import { InfoOutline } from '@/assets/icons';
import { useTranslation } from 'react-i18next';
import { media } from '@/styles/theme';

const DisabledRestermInfo = (): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Container>
      <Icon /> <span>{t`clientGigs.actionsDisabled`}</span>
    </Container>
  );
};

export { DisabledRestermInfo };

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(0, 138, 205, 0.1);
  color: #135188;
  font-size: 13px;
  margin-left: 0;
  padding: 6px 12px;
  border-radius: 4px;

  ${media.laptop} {
    margin-left: 8px;
  }
`;

const Icon = styled.div`
  background-image: url(${InfoOutline});
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  background-size: contain;

  ${media.laptop} {
    width: 12px;
    height: 12px;
  }
`;
